/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Review_Blue_DescriptionInputs */

const en_orders_review_blue_description = /** @type {(inputs: Orders_Review_Blue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for QC`)
};

const es_orders_review_blue_description = /** @type {(inputs: Orders_Review_Blue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo para control de calidad`)
};

/**
* | output |
* | --- |
* | "Ready for QC" |
*
* @param {Orders_Review_Blue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_review_blue_description = /** @type {((inputs?: Orders_Review_Blue_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Review_Blue_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_review_blue_description(inputs)
	return es_orders_review_blue_description(inputs)
});